<template>
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <futuro-logo />
      <futuro-text class="ml-1" />
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          Acesso não autorizado 🔐
        </h2>
        <p class="mb-2" >
          {{ 
            errorMessage? errorMessage: 
            'Você não tem permissão para acessar este conteúdo. Acesse sua conta e desfrute das funcionalidades do sistema!'
          }}
        </p>
        <b-button variant="primary" class="mb-1 btn-sm-block" :to="loginRoute()">Acessar o Oráculo</b-button>
        <b-img fluid :src="imgUrl" alt="Acesso não autorizado" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import FuturoLogo from '@core/layouts/components/Logo.vue'
import FuturoText from '@core/layouts/components/LogoText.vue'
import { BLink, BImg, BButton } from 'bootstrap-vue'
import store from '@/store/index'

export default {
  components: {
    BLink, BImg, BButton, FuturoLogo, FuturoText
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/not-authorized.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/not-authorized-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
    errorMessage() {
      const errorCode = this.$route.params.errorCode
      if(errorCode){
        switch (errorCode){
          case 'TOKEN_MISMATCH':
            return `Você foi desconectado pois foi identificado um novo acesso com as suas credenciais. 
              Para continuar utilizando esta sessão, conecte-se novamente ao Oráculo.`
          case 'TOKEN_EXPIRED':
            return `Sua sessão expirou, por favor realize um novo login.`
          case 'NO_PERMISSION':
            return `Seu perfil não possui permissão para acessar esta funcionalidade.
              Caso precise realizar esta ação, solicite diretamente ao Suporte.`
          default:
            return null
        }
      }
      return null
    }
  },
  methods: {
    loginRoute() {
      return { name: 'account-login' }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
